import * as React from "react";
import { CorrectionBreakdownItem } from './CorrectionBreakdownItem';
import { CorrectionPreview } from './CorrectionsPreview';
import { MiscCorrection, Correction } from '../Request/DcfRequestReducer';

export interface CorrectionPreviewPanelProps {
    corrections: Correction[];
    miscCorrection: MiscCorrection;
    onPrev: () => void;
    onNext: () => void;
}

export const CorrectionPreviewModal = (props: CorrectionPreviewPanelProps): JSX.Element => {
    const { onPrev, onNext, ...rest } = props;

    return (
        <>
            <div className="modal-body">
                <p className="text-muted">Summary of the correction to be added</p>
                <CorrectionPreview {...rest} />
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary btn-outline" type="button" onClick={onPrev}>Previous</button>
                <button className="btn btn-primary" type="button" onClick={onNext}>Next</button>
            </div>
        </>
    );
};
